package com.essntl.core.waypoint.domain

import com.essntl.core.waypoint.domain.models.*
import core.config.buildFlavor

interface WaypointClient {
    suspend fun sendEmail(template: SimpleEmailTemplateData): Result<String>

    suspend fun sendEmail(template: POServicesTemplate): Result<String>

    suspend fun waypointLogs(platformId: String): Result<List<WaypointLogs>>

    companion object {
        private val fromEmail = "noreply@odia.app"
        private val bccEmail = "noreply@odia.app"
        private val multiPoTemplateId = "wptemplate_KAbsGb43XBgLkvMy"

        private val messageTemplateId = "wptemplate_CuErvxczRUL5waSR"

        val multiPurchaseOrderTemplate =
            POServicesTemplate(
                templateId = multiPoTemplateId,
                from = fromEmail,
                bcc = bccEmail,
                replyTo = "",
                to = "",
                cc = "",
                variables = POServicesVariables.empty,
            )

        val simpleEmailTemplate =
            SimpleEmailTemplateData(
                templateId = messageTemplateId,
                from = fromEmail,
                bcc = bccEmail,
                replyTo = "",
                to = "",
                cc = "",
                variables = SimpleMessageVariables.empty,
            )
    }
}
